import { useState, useContext, useEffect } from "react"
import { TablePage, CSkeletonTable, TablePagination, ModalDelete, SearchSpinner, toast, CSelect } from "../../components/widget"
import { ContextNav, ContextLoading, ContextDashboard } from "../../context";
import { UsersApi, DeleteUserApi } from "../../api";
import { converDurationToMin } from "../../utils";
import { Link } from "react-router-dom";

export const Users = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [searchValue, setSearchValue] = useState<any>(null)
    const [jsonParms, setJsonParms] = useState<any>({ 'page': 1 , 'status':'active'})
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "کارمند ",
            render: (i: any) => (
                <div className="flex items-center h-[70px]">
                    {i.profile?.avatar &&
                        <img src={i.profile.avatar} className="w-[50px] h-[50px] rounded-full ml-2" />
                    }
                    <span className="mr-2">{i.name && i.name != null && i.name}</span>
                </div>)
        },
        {
            title: "شماره پرسنلی ",
            render: (i: any) => (<>{i.username && i.username != null && i.username}</>)
        },
        {
            title: "گروه شغلی",
            render: (i: any) => (<>{i.job_group && i.job_group != null && i.job_group.name}</>)
        },
        {
            title: "شغل",
            render: (i: any) => (<>{i.job && i.job != null && i.job.name}</>)
        },
        {
            title: "مرخصی ماهیانه",
            render: (i: any) => (<>{i.vacations_left && i.vacations_left != null && i.vacations_left?.monthly_left_vacations}</>)
        },
        {
            title: "مرخصی سالیانه",
            render: (i: any) => (<>{i.vacations_left && i.vacations_left != null && i.vacations_left?.yearly_left_vacations}</>)
        },
        {
            title: "وضعیت ",
            render: (i: any) => (
                <>
                    {i.status && i.status != null && i.status == 1 ? "فعال" : "غیرفعال"}
                </>
            )
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    <Link to={`/p/users/${i.id}`}>
                        <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                    </Link>
                    <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                </div>)
        },
    ]

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteUser = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteUserApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData(jsonParms)
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }

    const changePage = (type: string) => {
        let data = { ...jsonParms };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        setJsonParms(jsonParms)
        getData(data)
    }

    const handelSelectUserStatus = (e: any) => {
        let data = { ...jsonParms };
        data['status'] = e.target.value;
        setJsonParms(data)
        getData(data)
    }

    const handelSearch = () => {
        if (searchValue != null) {
            let data = { ...jsonParms };
            data['term'] = searchValue;
            setJsonParms(data)
            CtxLoad.setDisplayLoadingBtn(false)
            getData(data)

        }
        else {
            CtxLoad.setDisplayLoadingBtn(false)
        }

    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await UsersApi(parms)
            setTableData(res.data.data)
            CtxLoad.setDisplayLoadingSkelton(false)
            setCurrentPage(res.data.current_page)
            setLastPage(res.data.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        CtxLoad.setDisplayLoadingBtn(true)
        const timeoutId = setTimeout(() => handelSearch(), 1500);
        return () => clearTimeout(timeoutId);
    }, [searchValue]);

    useEffect(() => {
        document.title = "پرسنل | دایان"
        CtxNav.setActiveMenuItem({ 'item': 2, 'subItem': 0, })
        getData(jsonParms)
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">لیست کامل پرسنل</h1>

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className="w-full md:w-[49%] flex flex-wrap items-center justify-between">
                    <div className=" w-full md:w-[49%] w-full pl-2 overflow-hidden flex items-center bg-white md:mb-0 mb-2 h-[40px] md:h-[50px] rounded-md border-0 shadow">
                        <input onChange={(e: any) => { setSearchValue(e.target.value) }} type={'text'} placeholder="جستجو کارمند" className=" w-[calc(100%-30px)] h-full text-sm px-3 focus:outline-none" />
                        <div className=" w-[30px] h-[30px]  flex justify-center items-center">

                            {CtxLoad.displayLoadingBtn ?
                                <SearchSpinner />
                                :
                                <svg x="0px" y="0px" viewBox="0 0 487.95 487.95" className={`  w-[25px] fill-[#b9b2b2] `}>
                                    <use xlinkHref="/assetes/svg/search.svg#search" />
                                </svg>
                            }
                        </div>
                    </div>
                    <div className="w-full md:w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                        <CSelect placeholder={'انتخاب وضعیت'} onChange={(e: any) => handelSelectUserStatus(e)} >
                            <option value={'active'}>پرسنل فعال</option>
                            <option value={'notActive'}>پرسنل غیرفعال</option>
                            <option value={'all'}>همه</option>
                        </CSelect>
                    </div>
                </div>
                <div className=" w-full md:w-[50%] flex items-center justify-end md:mt-0 mt-[7px]">
                    <button className=" w-full md:w-[50%] px-[20px] h-[35px] md:h-[50px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                        <Link to='/p/users/add' className=" w-full h-full flex justify-center items-center">
                            + افزودن پرسنل جدید
                        </Link>
                    </button>
                </div>
            </div>

            <div className=" w-full ">
                {CtxLoad.displayLoadingSkelton == false ?
                    <TablePage columns={col} data={tableData} >
                        <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                    </TablePage>
                    :
                    <CSkeletonTable />
                }
            </div>

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteUser} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
